import {t} from 'i18next';
import React, {useMemo} from 'react';
import Modal from '../../incase-domain/components/modals/directory/Modal';
import useBodyScroll from '../../utils/hooks/useBodyScroll';
import {AnimatedSVG} from './Spinner';

interface SpinnerProps {
    active: boolean;
}

function SpinnerModal({active}: SpinnerProps): JSX.Element {
    useBodyScroll(active);

    return useMemo(
        () => (
            <Modal closeOnClickOutside={false} isOpen={active} onCancel={() => undefined} size="fit">
                <div className="u-flex u-flex-col u-v-center u-h-center u-gap-2 u-p-4">
                    <AnimatedSVG />
                    <div>{t('common.loader')}</div>
                </div>
            </Modal>
        ),
        [active]
    );
}

export default SpinnerModal;
